import assertEventType from 'common/bento/lib/assertEventType';
import { MachineServices } from 'common/bento/types/MachineConfig';
import { apolloClient } from 'common/graphql/clients';

import { SaveCompanyFinancialInfoDocument } from '../graphql/mutations/saveCompanyFinancialInfo.gql';
import { CompanyFinancialInfoDocument } from '../graphql/queries/companyFinancialInfo.gql';
import { Model } from './model';

export enum Service {
  SaveFinancialInfo = 'saveFinancialInfo',
}

const services: MachineServices<Model, Service> = {
  saveFinancialInfo: async ({ getModuleData }, event) => {
    assertEventType(event, 'SAVE_FINANCIAL_INFO');

    const { companyProfileId } =
      getModuleData().companyFinancialInfoData.viewer.company;

    const {
      legalAnnualTurnOver,
      legalNumberOfEmployeeRange,
      legalShareCapital,
    } = event.data;

    return apolloClient.mutate({
      awaitRefetchQueries: true,
      mutation: SaveCompanyFinancialInfoDocument,
      refetchQueries: [
        {
          query: CompanyFinancialInfoDocument,
          variables: {
            companyProfileId,
          },
        },
      ],
      variables: {
        input: {
          id: companyProfileId,
          legalAnnualTurnOver,
          legalNumberOfEmployeeRange,
          legalShareCapital,
        },
      },
    });
  },
};

export default services;
